<div class="dashboard">
  <div class="dashboard-background">&nbsp;</div>
  <div class="dashboard-title">
    <app-title
      title="DASHBOARD.TITLE.YOUR"
      subtitle="DASHBOARD.TITLE.DASHBOARD"
    ></app-title>
  </div>

  <div class="go-to-launchpad">
    <span (click)="gotoLaunchpadClicked()">
      <div class="title">
        <i
          class="fa fa-undo"
          aria-hidden="true"
        ></i>
        <div class="line1">{{ 'DASHBOARD.LAUNCHPAD.LINK.PART_1' | translate }}</div>
        <div class="line2">{{ 'DASHBOARD.LAUNCHPAD.LINK.PART_2' | translate }}</div>
      </div>
    </span>
  </div>

  <div
    class="tiles"
    @tile
  >
    <app-dashboard-orders-tile
      *ngIf="showOrdersTile"
      [authorization]="authorization"
      [contractInfo]="contractInfo"
    ></app-dashboard-orders-tile>
    <app-dashboard-flows-tile
      *ngIf="showFlowsTile"
      [authorization]="authorization"
      [contractInfo]="contractInfo"
    ></app-dashboard-flows-tile>
    <app-local-office-tile
      *ngIf="salesOrganisation?.contacts?.length"
      [ngClass]="{ double: salesOrganisation?.contacts?.length > 2 }"
      [salesOrganisation]="salesOrganisation"
    ></app-local-office-tile>
  </div>
</div>
